// main.jsx
import { createRoot } from 'react-dom/client'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import './index.css'
import App from './App.jsx'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import reldoTheme, { TOOLPAD_COLOR_SCHEME_STORAGE_KEY, TOOLPAD_MODE_STORAGE_KEY } from './theme/theme'

import DashboardPage from './pages/DashboardPage.jsx'
import Login from './pages/Login.jsx'
import RequestsPage from './pages/RequestsPage.jsx'
import ObjectsPage from './pages/ObjectsPage.jsx'
import CustomersPage from './pages/CustomersPage.jsx'


import Layout from './layout/Layout.jsx'

import MembersPage from './pages/MembersPage.jsx'
import OptionsPage from './pages/OptionsPage.jsx'
import NewObjectPage from './pages/NewObjectPage.jsx'
import ProtectedRoute from './components/ProtectedRoute.jsx'

import Register from './pages/Register.jsx'
import ForgotPassword from './components/ForgotPassword.jsx'
import TestPage from './pages/TestPage.jsx'
import PaymentPage from './pages/PaymentPage.jsx'
import ShareObjectPage from './pages/ShareObjectPage.jsx'
import HelpPage from './pages/HelpPage.jsx'
import ParserPage from './pages/ParserPage.jsx'
import VerifyEmail from './pages/VerifyEmail.jsx'
import VerificationPending from './pages/VerificationPending.jsx'
import ResetPassword from './pages/ResetPassword.jsx'
import AvitoPage from './pages/AvitoPage.jsx'
import AdminApp from './admin/AdminApp.jsx'
import ImpersonationView from './admin/ImpersonationView.jsx'





const router = createBrowserRouter([
	{ path: '/admin/*', Component: AdminApp },
	{ path: '/impersonation', Component: ImpersonationView },
	
	{
		Component: App,
		children: [
			{
				path: '/',
				Component: Layout,
				children: [
					{
						path: '/',
						/* Component: DashboardPage, // Открытый маршрут (временно) */
						Component: () => (
							<ProtectedRoute>
								<DashboardPage />
							</ProtectedRoute>
						),
					},
					{
						path: '/newobject',
						Component: () => (
							<ProtectedRoute>
								<NewObjectPage />
							</ProtectedRoute>
						),
					},
					{
						path: '/requests',
						Component: () => (
							<ProtectedRoute>
								<RequestsPage />
							</ProtectedRoute>
						),
					},
					{
						path: '/objects',
						Component: () => (
							<ProtectedRoute>
								<ObjectsPage />
							</ProtectedRoute>
						),
					},
					{
						path: '/customers',
						Component: () => (
							<ProtectedRoute>
								<CustomersPage />
							</ProtectedRoute>
						),
					},
					{
						path: '/members',
						Component: () => (
							<ProtectedRoute>
								<MembersPage />
							</ProtectedRoute>
						),
					},
					{
						path: '/avito',
						Component: () => (
							<ProtectedRoute>
								<AvitoPage />
							</ProtectedRoute>
						),
					},
					{
						path: '/options',
						Component: () => (
							<ProtectedRoute>
								<OptionsPage />
							</ProtectedRoute>
						),
					},
					{
						path: '/payment',
						Component: () => (
							<ProtectedRoute>
								<PaymentPage />
							</ProtectedRoute>
						),
					},
					{
						path: '/help',
						Component: () => (
							<ProtectedRoute>
								<HelpPage />
							</ProtectedRoute>
						),
					},
					{
						path: '/parser',
						Component: () => (
							<ProtectedRoute>
								<ParserPage />
							</ProtectedRoute>
						),
					},
					{
						path: '/test12345test',
						Component: () => (
							<ProtectedRoute>
								<TestPage />
							</ProtectedRoute>
						),
					},
					// Добавьте другие маршруты
				],
			},
			{
				// Логин не использует Layout
				path: '/login',
				Component: Login,
			},
			{
				// Логин не использует Layout
				path: '/register',
				Component: Register,
			},
			{
				// Логин не использует Layout
				path: '/forgot',
				Component: ForgotPassword,
			},
			{ path: '/verify-email', Component: VerifyEmail },
			{ path: '/verify-email-pending', Component: VerificationPending },
			{ path: '/reset-password', Component: ResetPassword },
			{
				// не использует Layout
				path: '/share/:uuid',
				Component: ShareObjectPage,
			},
		],
	},
])


createRoot(document.getElementById('root')).render(
	<ThemeProvider
		theme={reldoTheme}
		modeStorageKey={TOOLPAD_MODE_STORAGE_KEY}
		colorSchemeStorageKey={TOOLPAD_COLOR_SCHEME_STORAGE_KEY}
		disableTransitionOnChange
	>
		<CssBaseline enableColorScheme />
		<RouterProvider router={router} />
	</ThemeProvider>
)
